export const emailToolbarConfig = {
  header: true,
  font: true,
  size: true,
  bold: true,
  italic: true,
  color: true,
  background: true,
  listBullet: true,
  listOrdered: true,
  align: true,
  addLink: true,
  addImage: true,
  addVariable: true,
}

export const aiFlowStates = {
  initial: 'initial',
  generating: 'generating',
  pendingFeedback: 'pending_feedback',
  improving: 'improving',
}

export const customerEmailCopies = {
  title: 'Contactar con el cliente',
  to: 'Email del cliente',
  replyTo: 'Email de respuesta para clientes (Reply-to)',
}
